import { useState } from 'react'

export interface IInputData {
  value: string
  setValue: (value: string) => void
  reset: () => void
  bind: {
    value: string
    onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void
  }
  error?: string
  setError: (value?: string) => void
}

export function useInput(initialValue: string): IInputData {
  const [value, setValue] = useState<string>(initialValue)
  const [error, setError] = useState<string | undefined>(undefined)

  return {
    value,
    setValue,
    reset: () => setValue(''),
    bind: {
      value,
      onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        setValue(event.target.value)
      },
    },
    error,
    setError,
  }
}
